import "./font.css";

import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {ThemeProvider} from "styled-components";

import {AppRouter} from "@/router/Router";

import {AppContextProvider} from "./context/AppContext";
import {UserParamContextProvider} from "./context/UserParamContext";
import {GlobalStyle, theme} from "./GlobalStyle";

const documentRoot = document.getElementById("root");
if (documentRoot) {
  createRoot(documentRoot).render(
    <StrictMode>
      {/* Permet de définir le type d'utilisateur en fonction du hostname */}
      <AppContextProvider>
        {/* Permet à l'utilisateur de sélectionner la campagne et la contremarque */}
        <UserParamContextProvider>
          <ThemeProvider theme={theme}>
            <GlobalStyle />
            <AppRouter />
          </ThemeProvider>
        </UserParamContextProvider>
      </AppContextProvider>
    </StrictMode>
  );
}
